export default {
	notification_health: 'അറിയിപ്പ് ആരോഗ്യം',
	notification_health_summary: 'സംഗ്രഹം',
	notification_health_loading: 'അറിയിപ്പ് ആരോഗ്യം പരിശോധിക്കുന്നു...',
	notification_health_refresh: 'പുതുക്കുക',
	notification_health_fix: 'എന്ത് ചെയ്യണം',
	notification_health_unavailable: 'അറിയിപ്പ് ആരോഗ്യം ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല',
	notification_health_healthy: 'ശരിയാണ്',
	notification_health_blocked: 'തടഞ്ഞിരിക്കുന്നു',
	notification_health_degraded: 'ശ്രദ്ധ ആവശ്യമാണ്',
	notification_health_no_app_user: 'ആപ്പ് ലോഗിൻ ഇല്ല',
	notification_health_unknown: 'അജ്ഞാതം',
	notification_health_app_version: 'ആപ്പ് പതിപ്പ്',
	notification_health_last_delivery: 'അവസാന ഡെലിവറി',
	notification_health_time_just_now: 'ഇപ്പോൾ തന്നെ',
	notification_health_time_minutes: '{count} മിനിറ്റ് മുമ്പ്',
	notification_health_time_hours: '{count} മണിക്കൂർ മുമ്പ്',
	notification_health_time_days: '{count} ദിവസം മുമ്പ്',
	notification_health_time_unknown: 'അജ്ഞാതം',
	notification_health_summary_healthy: 'അറിയിപ്പുകൾ പ്രവർത്തിക്കണം',
	notification_health_summary_no_app_user: 'ക്ലീനർ മൊബൈൽ ആപ്പിൽ ലോഗിൻ ചെയ്തിട്ടില്ല',
	notification_health_summary_blocked_no_token: 'പുഷ് ടോക്കൺ കാണുന്നില്ല — ക്ലീനർ ആപ്പ് തുറന്ന് ലോഗിൻ ചെയ്യണം',
	notification_health_summary_blocked_off: 'ആപ്പിൽ അറിയിപ്പുകൾ ഓഫാണ്',
	notification_health_check_portal_contact_label: 'പോർട്ടൽ കോൺടാക്റ്റ് ഉണ്ട്',
	notification_health_check_portal_active_label: 'കോൺടാക്റ്റ് സജീവമാണ്',
	notification_health_check_portal_rooms_label: 'റൂമുകൾ നിയോഗിച്ചിരിക്കുന്നു',
	notification_health_check_portal_shifts_label: 'ഷിഫ്റ്റുകൾ നിയോഗിച്ചിരിക്കുന്നു',
	notification_health_check_app_user_label: 'മൊബൈൽ ആപ്പിൽ ലോഗിൻ ചെയ്തു',
	notification_health_check_push_token_label: 'പുഷ് ടോക്കൺ രജിസ്റ്റർ ചെയ്തു',
	notification_health_check_notification_mode_label: 'അറിയിപ്പ് മോഡ്',
	notification_health_check_time_schedule_label: 'അറിയിപ്പ് നിയമിച്ച സമയത്തിനുള്ളിൽ',
	notification_health_check_ios_geo_filter_label: 'iOS ലൊക്കേഷൻ ഫിൽട്ടർ',
	notification_health_check_recent_push_attempt_label: 'സമീപകാല പുഷ് ശ്രമം (48മ)',
	notification_health_check_last_push_ignored_label: 'അവസാന സിഗ്നൽ അയച്ചില്ല',
	notification_health_check_recent_push_delivered_label: 'സമീപകാല പുഷ് ഡെലിവർ ചെയ്തു (48മ)',
	notification_health_detail_portal_contact_found: 'പോർട്ടലിൽ കണ്ടെത്തി',
	notification_health_detail_portal_contact_missing: 'കോൺടാക്റ്റ് റെക്കോർഡ് കണ്ടെത്തിയില്ല',
	notification_health_detail_portal_active_active: 'സജീവം',
	notification_health_detail_portal_active_inactive: 'നിഷ്ക്രിയം',
	notification_health_detail_portal_rooms_assigned: '{count} റൂം(കൾ)',
	notification_health_detail_portal_rooms_none: 'റൂമുകൾ നിയോഗിച്ചിട്ടില്ല',
	notification_health_detail_portal_shifts_assigned: '{count} ഷിഫ്റ്റ്(കൾ)',
	notification_health_detail_portal_shifts_none: 'ഷിഫ്റ്റുകൾ നിയോഗിച്ചിട്ടില്ല',
	notification_health_detail_app_user_logged_in: 'ആപ്പ് പതിപ്പ് {version}, അവസാന സിങ്ക് {lastSync}',
	notification_health_detail_app_user_never: 'ഒരിക്കലും ലോഗിൻ ചെയ്തിട്ടില്ല',
	notification_health_detail_push_token_present: 'FCM ടോക്കൺ ഉണ്ട്',
	notification_health_detail_push_token_empty: 'ടോക്കൺ ശൂന്യമാണ്',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'നിലവിലെ സമയം ഷെഡ്യൂളിനുള്ളിലാണ്',
	notification_health_detail_time_schedule_outside: 'നിലവിലെ സമയം ക്രമീകരിച്ച ഷെഡ്യൂളിന് പുറത്താണ്',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'കഴിഞ്ഞ 48 മണിക്കൂറിൽ പുഷ് ശ്രമങ്ങളൊന്നുമില്ല',
	notification_health_detail_last_push_ignored: 'അവസാന പുഷ് അഭ്യർത്ഥന അവഗണിച്ചു (servik ജോലി പ്രദേശത്തിന് കോൺഫിഗർ ചെയ്തിട്ടില്ല)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'കഴിഞ്ഞ 48 മണിക്കൂറിൽ വിജയകരമായ ഡെലിവറികളൊന്നുമില്ല',
	notification_health_fix_portal_contact: 'ഉപയോക്താക്കൾ പാനലിൽ ഈ ക്ലീനറെ സൃഷ്ടിക്കുക',
	notification_health_fix_portal_active: 'ഈ ക്ലീനറിനായി സജീവം ടോഗിൾ ഓണാക്കുക',
	notification_health_fix_portal_rooms: 'ഈ ക്ലീനറിന് കുറഞ്ഞത് ഒരു റൂം നിയോഗിക്കുക',
	notification_health_fix_portal_shifts: 'കുറഞ്ഞത് ഒരു ഷിഫ്റ്റ് നിയോഗിക്കുക',
	notification_health_fix_app_user: 'ക്ലീനർ ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്ത് ഈ ഫോൺ നമ്പർ ഉപയോഗിച്ച് ലോഗിൻ ചെയ്യണം',
	notification_health_fix_push_token: 'ക്ലീനറോട് ആപ്പ് തുറക്കാനും iOS സെറ്റിംഗ്സിൽ അറിയിപ്പുകൾ അനുവദിക്കാനും വീണ്ടും ലോഗിൻ ചെയ്യാനും പറയുക',
	notification_health_fix_notification_mode: 'ആപ്പിൽ അറിയിപ്പ് മോഡ് ഓഫിൽ നിന്ന് എപ്പോഴും എന്നാക്കി മാറ്റുക',
	notification_health_fix_time_schedule: 'നിയമിച്ച സമയം വരെ കാത്തിരിക്കുക അല്ലെങ്കിൽ മോഡ് എപ്പോഴും എന്നാക്കി മാറ്റുക',
	notification_health_fix_ios_geo_filter: 'ക്ലീനർ അറിയിപ്പ് സോണിന് പുറത്താണ് — സൈറ്റിൽ ആപ്പ് തുറക്കാൻ പറയുക',
	notification_health_fix_last_push_ignored: 'സിഗ്നൽ ട്രിഗർ ചെയ്ത റൂമിന്റെ ജോലി പ്രദേശ servik കോൺഫിഗറേഷൻ പരിശോധിക്കുക',
	notification_health_fix_recent_push_delivered_filters: 'അറിയിപ്പ് ഫിൽട്ടറുകൾ അല്ലെങ്കിൽ ഉപകരണ സെറ്റിംഗ്സ് പരിശോധിക്കുക',
	notification_health_fix_recent_push_delivered_token: 'ആദ്യം പുഷ് ടോക്കൺ രജിസ്റ്റർ ചെയ്യുക',
	notification_health_mode_on: 'എപ്പോഴും',
	notification_health_mode_off: 'ഓഫ്',
	notification_health_mode_time: 'സമയ അടിസ്ഥാനത്തിൽ',
	notification_health_mode_location: 'ലൊക്കേഷൻ അടിസ്ഥാനത്തിൽ',
	notification_health_filter_on: 'ഓൺ',
	notification_health_filter_off: 'ഓഫ്',
};
